// extracted by mini-css-extract-plugin
export default {"container":"w0-z","heading":"x0-z","links":"y0-z","copy":"z0-z","subCopy":"A0-z","linksLeft":"B0-z","linksCenter":"C0-z","linksRight":"D0-z","link":"E0-z","onlyLink":"F0-z"};